import { createReducer, on } from '@ngrx/store';
import { PayrollUIActions } from 'app/main/payroll/actions';
import { PayrollUIState } from 'app/main/payroll/payroll.types';

const initialState: PayrollUIState = {
  selectedTab: 0,
  selectedFilterSynthese: 'Analytics',
  selectViewTypeSynthese: 'cash',
  selectedYears: [],
  selectedFilterKeys: [],
  selectedFilter: [
    {
      title: 'Brut chargé',
      key: 'fullRawCharges',
      isCollapse: true,
      styleClass: 'head-1',
      checked: true,
      children: [
        {
          title: 'Elements du brut',
          key: 'fullRaw',
          isCollapse: true,
          checked: true,
          styleClass: 'head-2',
          children: [
            { title: 'Brut', key: 'raw', checked: true },
            { title: 'Prime', key: 'primes', checked: true },
            { title: 'Heures supp', key: 'extra', checked: true },
            { title: 'Autre brut', key: 'others', checked: true },
          ],
        },
        {
          title: 'Charges patronales',
          key: 'charges',
          checked: true,
          styleClass: 'head-2',
        },
      ],
    },
  ],
};

export const reducer = createReducer(
  initialState,
  on(
    PayrollUIActions.payrollSetSelectedTab,
    (state, { selectedTab }): PayrollUIState => ({
      ...state,
      selectedTab,
    })
  ),
  on(
    PayrollUIActions.payrollSetSelectedYears,
    (state, { selectedYears }): PayrollUIState => ({
      ...state,
      selectedYears,
    })
  ),
  on(
    PayrollUIActions.payrollSetSelectedFilter,
    (state, { selectedFilter, selectedFilterKeys }): PayrollUIState => ({
      ...state,
      selectedFilter,
      selectedFilterKeys
    })
  ),
  on(
    PayrollUIActions.payrollSetSelectedFilterSynthese,
    (state, { selectedFilterSynthese }): PayrollUIState => ({
      ...state,
      selectedFilterSynthese,
    })
  ),
  on(
    PayrollUIActions.payrollSetViewTypeSynthese,
    (state, { selectViewTypeSynthese }): PayrollUIState => ({
      ...state,
      selectViewTypeSynthese,
    })
  ),
);
